var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-down-btn-container"},_vm._l((_vm.hostLinks),function(item){return _c('div',{key:item.id,staticClass:"btn",on:{"click":function($event){return _vm.handClick(item.hostLink)}}},[_c('Img',{attrs:{"width":'23.5rem',"height":'6.8rem',"url":item.btn +'-' + _vm.$i18n.locale +'.png',"alt":_vm.$t(item.describe)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }